export default __webpack_public_path__ + "static/media/Phone.369ade47.svg";